import { render, staticRenderFns } from "./POSInvoices.vue?vue&type=template&id=47069202&scoped=true"
import script from "./POSInvoices.vue?vue&type=script&lang=js"
export * from "./POSInvoices.vue?vue&type=script&lang=js"
import style0 from "./POSInvoices.vue?vue&type=style&index=0&id=47069202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47069202",
  null
  
)

export default component.exports